import { put } from "../../../infra/rest";

interface InvoiceReportResponse {
  url: {
    url: string;
  };
}

const downloadInvoiceReportAPI = async (
  payoutCommissionId: string
) => {
  if (!payoutCommissionId) {
    throw new Error('Invoice report not found');
  }

  const url = '/v1/channel-partner/invoice-working-report';
  const response = await put<InvoiceReportResponse>(
    url,
    {
      body: JSON.stringify({
        invoiceId: payoutCommissionId
      }),
    },
    true
  );

  if (response.url?.url) {
    const link = document.createElement('a');
    link.href = response.url.url;
    const urlParts = response.url.url.split('/');
    const fileName = urlParts[urlParts.length - 1].split('?')[0];
    link.download = fileName;

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
}

export default downloadInvoiceReportAPI;
